// extracted by mini-css-extract-plugin
export default {"shape":"Portfolio_shape__eOcYM","pTable":"Portfolio_pTable__-F-uV"};